import React from "react";
import Notification from "../layout/Notification";
import Helping from "../../helpers/Helping";
import { APP_VISION } from "../../config/urls";
import Service from "../../helpers/service";
import LoadingButton from "../fields/LoadingButton";

class AppVision extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      link: "",
      isLoading: true,
      btnIsDisable: false,
      is_active: true,
      appVersion: '',
    };

    this.handleValueChange = this.handleValueChange.bind(this)
    this.onUpload = this.onUpload.bind(this)
  }

  removeNetworkError = () => {
    this.setState({ ...Helping.clearNetworkRequest() });
  }

  handleValueChange = async (e) => {
    const { name, value } = e.target;
    let self = this;

    this.setState({ [name]: value }, () => {
      self.btnEnable()
    });
  }

  btnEnable() {
    if (this.state.link && this.state.appVersion) {
      this.setState({ is_active: false })
    }
    else {
      this.setState({ is_active: true })
    }
  }

  resetForm = () => {
    this.setState({
      link: "",
      appVersion: "",
      btnIsDisable: false,
      is_active: true
    })
  }

  onUpload(e) {
    let self = this,
      body = {
        app: 'terradome',
        url: this.state.link,
        version: this.state.appVersion
      }

    this.setState({
      btnIsDisable: true
    })

    Service.postCall(APP_VISION, body)
      .then((response) => {
        console.log(response);
        self.setState({
          error_message: response.data.message,
          error_type: 'success',
          btnIsDisable: false
        }, () => this.resetForm());
      })
      .catch((error) => {
        if (error.response) {
          Helping.redirectToLogin(error);
          return self.setState({
            error_message: error.response.data.message,
            error_type: 'danger',
            isLoading: false,
            btnIsDisable: false
          }
          );
        }
        return this.setState({
          isLoading: false,
          btnIsDisable: false,
          ...Helping.setNetworkRequestError(error, 'uploading'),
        }
        );
      });
  }

  render() {
    return (
      <div class="content nft-form">
        <div class="top-header d-block">
          <div class="header-title">
            <h2 class="title">App Vision</h2>
            <span class="title-caption">You can view vision here.</span>
          </div>
        </div>

        <div class="main-content">
          {this.state.error_message &&
            <Notification
              type={this.state.error_type}
              message={this.state.error_message}
              callback={this.removeNetworkError}
            />
          }

          <form action="" class="appvision-form">
            <div class="form-group">
              <label for="visionLink">Link </label>
              <input type="text" name="link" id="visionLink" value={this.state.link} class="form-control" onChange={(e) => this.handleValueChange(e)} />
            </div>
            <div class="form-group">
              <label for="appVersion">App Version</label>
              <input type="text" name="appVersion" id="appVersion" value={this.state.appVersion} class="form-control" onChange={(e) => this.handleValueChange(e)} />
            </div>
            <div class="content-btn">
              <button type="reset" class="custom-btn sm-btn semi-dark-btn border-btn" onClick={this.resetForm}>Reset</button>

              {this.state.btnIsDisable ?
                <LoadingButton class_name={"sm-btn"} />
                :
                <button type="submit" class="custom-btn sm-btn gradiant-btn" disabled={this.state.is_active} onClick={(e) => this.onUpload(e)}>{this.state.btnIsDisable ? "Uploading..." : "Upload"}</button>
              }
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default AppVision;
